import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestUpdates from './components/LatestUpdates';
import HotComics from './components/HotComics';
import RankingSection from './components/RankingSection';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '哔咔漫画网',
        url: 'http://xiaodianba.cn/',
        description: '哔咔漫画网是免费漫画大全平台，收录各类热门漫画在线阅读资源，涵盖国内外精品漫画，无需注册即可免费观看。',
        sameAs: [
          'http://xiaodianba.cn/',
        ],
      },
      {
        '@type': 'WebSite',
        name: '哔咔漫画网',
        url: 'http://xiaodianba.cn/',
        description: '免费漫画大全 - 热门漫画在线阅读平台',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://xiaodianba.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '哔咔漫画网 - 免费漫画大全 - 热门漫画在线阅读',
        description: '哔咔漫画网是免费漫画大全平台，收录各类热门漫画在线阅读资源，涵盖国内外精品漫画，无需注册即可免费观看。',
        url: 'http://xiaodianba.cn/',
        isPartOf: { '@id': '#website' },
        about: { '@id': '#organization' },
      },
    ],
  };

  return (
    <>
      <title>哔咔漫画网 - 免费漫画大全 - 热门漫画在线阅读</title>
      <meta name="description" content="哔咔漫画网是免费漫画大全平台，收录各类热门漫画在线阅读资源，涵盖国内外精品漫画，无需注册即可免费观看。热血、玄幻、恋爱、科幻等多元题材，每日更新高清画质。" />
      <meta name="keywords" content="哔咔漫画网,免费漫画大全,热门漫画,在线阅读" />
      <link rel="canonical" href="http://xiaodianba.cn/" />
      <meta property="og:title" content="哔咔漫画网 - 免费漫画大全 - 热门漫画在线阅读" />
      <meta property="og:description" content="哔咔漫画网是免费漫画大全平台，收录各类热门漫画在线阅读资源，涵盖国内外精品漫画，无需注册即可免费观看。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://xiaodianba.cn/" />
      <meta property="og:site_name" content="哔咔漫画网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="哔咔漫画网 - 免费漫画大全 - 热门漫画在线阅读" />
      <meta name="twitter:description" content="无需注册即可免费观看国内外精品漫画，每日更新高清画质。" />
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <LatestUpdates />
          <HotComics />
          <RankingSection />
          <CategorySection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}
